"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalCategoryTypes = void 0;
exports.PortalCategoryTypes = [
    'manual',
    'automatic',
    'gift',
    'eventsCalendar',
];
